import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Paperclip, Download, Trash2, Loader2 } from "lucide-react";
import { api, errMsg, fmtDate, download } from "../../lib/api";

export default function Attachments({ module, recordId, writable, canDelete }) {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);
  const input = useRef(null);
  const load = () => api.get(`/records/${module}/${recordId}/attachments`).then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => {
    load();
  }, [module, recordId]); // eslint-disable-line react-hooks/exhaustive-deps
  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      await api.post(`/records/${module}/${recordId}/attachments`, fd);
      toast.success("File attached");
      load();
    } catch (err) {
      toast.error(errMsg(err));
    }
    setBusy(false);
    e.target.value = "";
  };
  const remove = async (a) => {
    if (!window.confirm(`Remove ${a.filename}?`)) return;
    try {
      await api.delete(`/attachments/${a.id}`);
      load();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <div className="border-t border-slate-200 pt-4" data-testid="attachments-section">
      <div className="flex items-center justify-between mb-2">
        <p className="text-sm font-semibold">Attachments</p>
        {writable && (
          <>
            <input ref={input} type="file" className="hidden" onChange={upload} data-testid="attachment-file-input" />
            <button type="button" disabled={busy} onClick={() => input.current.click()} className="inline-flex items-center gap-1.5 text-sm font-semibold text-sky-700" data-testid="attachment-upload-btn">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Paperclip className="w-4 h-4" />}Attach file
            </button>
          </>
        )}
      </div>
      {rows.length === 0 ? <p className="text-xs text-slate-500">No files attached. PDF, images, Office, CAD (DXF/DWG/STEP), up to 20 MB.</p> : (
        <ul className="space-y-1">
          {rows.map((a) => (
            <li key={a.id} className="flex items-center gap-3 text-sm" data-testid={`attachment-${a.id}`}>
              <span className="flex-1 truncate">{a.filename}</span>
              <span className="text-xs text-slate-500 hidden sm:inline">{Math.ceil(a.size / 1024)} KB · {a.uploaded_by} · {fmtDate(a.created_at)}</span>
              <button type="button" onClick={() => download(`/attachments/${a.id}`, a.filename).catch((e) => toast.error(errMsg(e)))} className="text-sky-700" aria-label="Download"><Download className="w-4 h-4" /></button>
              {writable && canDelete && <button type="button" onClick={() => remove(a)} className="text-red-600" aria-label="Remove"><Trash2 className="w-4 h-4" /></button>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
